import { render, staticRenderFns } from "./ChatProjectFileSelector.vue?vue&type=template&id=3848d342&scoped=true&"
import script from "./ChatProjectFileSelector.vue?vue&type=script&lang=js&"
export * from "./ChatProjectFileSelector.vue?vue&type=script&lang=js&"
import style0 from "./ChatProjectFileSelector.vue?vue&type=style&index=0&id=3848d342&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3848d342",
  null
  
)

export default component.exports